var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBusiness = function SvgBusiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 37",
    fill: "#5663FF",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.936.871H3.742a3.548 3.548 0 0 0-3.53 3.548L.193 32.806a3.548 3.548 0 0 0 3.53 3.549h21.308a3.559 3.559 0 0 0 3.549-3.548v-21.29L17.936.87Zm3.548 28.387H7.29V25.71h14.194v3.548Zm0-7.097H7.29v-3.548h14.194v3.548Zm-5.323-8.87V3.531l9.758 9.758h-9.758Z"
  })));
};
export default SvgBusiness;